<template>
  <v-card
    flat
    tile
    :max-width="$vuetify.breakpoint.mobile ? '500px' : '800px'"
    class="mx-auto mb-2"
  >
    <!-- Header Section -->
    <v-list-item class="px-0 pb-2">
      <v-list-item-avatar
        class="mr-3"
        :size="$vuetify.breakpoint.mobile ? 40 : 50"
        @click="openProfile()"
      >
        <v-img
          v-if="userData.picture"
          :src="userData.picture"
          :width="$vuetify.breakpoint.mobile ? '30px' : '40px'"
        ></v-img>
        <user-logo v-else :size="$vuetify.breakpoint.mobile ? 40 : 50" />
      </v-list-item-avatar>
      <v-list-item-content>
        <!-- <v-list-item-title v-if="userData.name" class="text-sm md:text-lg d-flex align-center">
            {{ userData.name }}
          </v-list-item-title>
          <v-list-item-title v-else>
            username
          </v-list-item-title> -->
        <v-list-item-subtitle class="text-xs md:text-base">
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-img
          src="https://seeklogo.com/images/G/google-my-bussines-logo-554E98BE88-seeklogo.com.png"
          :width="$vuetify.breakpoint.mobile ? '30px' : '40px'"
        ></v-img>
      </v-list-item-action>
    </v-list-item>

    <!-- Preview Mode Content -->
    <v-card-text class="pa-0 px-2" v-if="hasPreview">
      <div
        v-html="
          google_business_profile_text ? google_business_profile_text : content
        "
        class="mb-4 text-body-1"
        :class="$vuetify.breakpoint.mobile ? 'text-lg' : 'text-h6'"
      />
    </v-card-text>
    <v-card :href="url" target="_blank" v-if="hasPreview" class="mx-2 mb-3">
      <v-img
        :src="detail?.image"
        :height="$vuetify.breakpoint.mobile ? '200px' : '300px'"
      />
      <v-card-title
        :class="$vuetify.breakpoint.mobile ? 'text-h6' : 'text-h5'"
        >{{ detail?.title }}</v-card-title
      >
      <v-card-text
        :class="$vuetify.breakpoint.mobile ? 'text-body-2' : 'text-body-1'"
        >{{ detail?.description }}</v-card-text
      >
    </v-card>

    <!-- Regular Mode Content -->
    <v-card-text v-else class="pa-0">
      <!-- Offer Post Layout -->
      <div v-if="isOfferPost" class="px-2">
        <!-- Offer Title -->
        <div class="text-h5 font-weight-bold mb-2">
          {{ configuration.gmb_offerDetails.title }}
        </div>

        <!-- Validity Period -->
        <div class="text-subtitle-1 mb-3">
          Valid
          {{
            formatDateRange(
              configuration.gmb_offerDetails.start,
              configuration.gmb_offerDetails.end
            )
          }}
        </div>

        <!-- Post Text -->
        <div v-html="content" class="mb-3 text-lg" />

        <!-- Terms and Conditions -->
        <div
          v-if="configuration.gmb_offerDetails.terms"
          class="text-caption grey--text text--darken-1"
        >
          {{ configuration.gmb_offerDetails.terms }}
        </div>
      </div>

      <!-- Standard Post Layout -->
      <div v-else class="px-2">
        <div
          v-html="
            google_business_profile_text
              ? google_business_profile_text
              : content
          "
          class="mb-3 text-lg"
        />
        <div v-html="hashtags" class="text-lg" />
      </div>

      <!-- Media Content - Responsive layout -->
      <div class="px-2 mt-3" v-if="carousels.length">
        <v-carousel
          hide-delimiters
          v-model="carousel"
          :show-arrows="carousels.length > 1"
          :height="$vuetify.breakpoint.mobile ? '400px' : '500px'"
          class="rounded"
        >
          <v-carousel-item v-for="(item, i) in carousels" :key="i">
            <div class="d-flex align-center justify-center h-full black">
              <v-img
                :src="item.src || item"
                v-if="item.type == 'image'"
                contain
                class="h-full"
              />
              <video-auto-play
                v-if="item.type == 'video'"
                :autoplay="false"
                :videoSrc="item.src"
              />
            </div>
          </v-carousel-item>
        </v-carousel>
      </div>
    </v-card-text>
    <v-divider class="mt-3"></v-divider>
  </v-card>
</template>

<script>
import UserLogo from "@/components/UserLogo.vue";
import VideoAutoPlay from "@/components/public/VideoAutoPlay.vue";
import moment from "moment";

export default {
  components: { UserLogo, VideoAutoPlay },
  props: {
    post: {
      type: Object,
      default: () => ({}),
    },
    userData: {
      type: Array,
      default: () => [],
    },
    detail: Object,
    hasPreview: Boolean,
    url: String,
    google_business_profile_text: String,
    configuration: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      carousel: 0,
    };
  },
  computed: {
    isOfferPost() {
      return this.configuration?.gmb_post_type === "OFFER";
    },
    logoName() {
      let name = this.currentUser.display_name || "";
      return name.charAt(0).toUpperCase();
    },
    hashtags() {
      let hashtags = this.post.hashtags || [];
      return hashtags
        .map((i) => {
          if (!i.startsWith("#")) return `#${i}`;
          return i;
        })
        .toString()
        .split(",")
        .join(" ");
    },
    content() {
      let content = this.post.text || "";
      // content = content.toString().replace(/(?:\r\n|\r|\n)/g, " <br>");
      content = content.toString().replace(/(?:\r\n|\r|\n)+/g, "<br>");
      content = content.replace(
        /(https?:\/\/[^\s]+)/g,
        '<a href="$1" target="_blank" class="primary--text text-decoration-underline">$1</a>'
      );

      // Optional footer
      if (this.post.include_footer && this.post.post_footer_value) {
        const footer = this.post.post_footer_value
          .toString()
          .replace(/(?:\r\n|\r|\n)+/g, "<br>")
          .replace(
            /(https?:\/\/[^\s]+)/g,
            '<a href="$1" target="_blank" class="primary--text text-decoration-underline">$1</a>'
          );

        // Append footer on a new line
        content += "<br>" + footer;
      }
      return content;
    },
    carousels() {
      let list = [];
      if (this.post.videos) {
        // console.log(this.post.videos);
        this.post.videos.forEach((item) => {
          list.push({
            src: item.url || item,
            type: "video",
          });
        });
      }
      if (this.post.images) {
        if (this.post.images.length > 1) {
          let images = this.post.images.slice(0, 1);
          images.forEach((item) => {
            list.push({
              src: item.thumbnail || item.url || item,
              type: "image",
            });
          });
        } else {
          this.post.images.forEach((item) => {
            list.push({
              src: item.thumbnail || item.url || item,
              type: "image",
            });
          });
        }
      }
      return list;
    },
  },
  methods: {
    formatDateRange(startDate, endDate) {
      if (!startDate || !endDate) return "";

      const start = moment(startDate).format("DD MMM");
      const end = moment(endDate).format("DD MMM");

      return `${start} - ${end}`;
    },
  },
};
</script>

<style scoped>
.text-h5 {
  font-size: 1.5rem !important;
  line-height: 1.2 !important;
}

.text-subtitle-1 {
  font-size: 1rem !important;
  line-height: 1.5 !important;
}

.text-caption {
  font-size: 0.875rem !important;
  line-height: 1.25 !important;
}
</style>
